import { Props } from "../../../propTypes";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import {
    eGroupCollection,
    eGroupSection,
} from "../../../../store/egroups/types";
import Swiper, { SwiperSlideType } from "./Swiper";
import { SelectedCampus } from "./types";

export interface IAppProps {
    eGroupSection: eGroupSection;
    uuid: string;
    selectedCampus: SelectedCampus | null;
    collections: eGroupCollection[];
}

const Collections = (props: IAppProps & Props) => {
    const { layout } = props.eGroupSection;
    const activeCollections = props.collections
        .filter((item) => item.isActive)
        .sort((a, b) => a.order - b.order)
        .slice(0, layout.maxItemsToLoad);
    if (layout === null || activeCollections.length === 0) {
        return null;
    }
    let slidesPerView = 1;
    const slides: SwiperSlideType[] = [];

    if (
        process.browser &&
        window.innerWidth < props.main.phoneMaxSize &&
        layout.itemsToShowMobile
    ) {
        slidesPerView = layout.itemsToShowMobile;
    } else if (
        process.browser &&
        window.innerWidth > props.main.phoneMaxSize &&
        layout.itemsToShowDesktop
    ) {
        slidesPerView = layout.itemsToShowDesktop;
    }

    activeCollections.forEach((collection) => {
        if (
            collection.link &&
            collection.layout &&
            ((layout.collectionsGroup &&
                layout.collectionsGroup === collection.group) ||
                !layout.collectionsGroup)
        ) {
            let link = "";

            if (collection.link) {
                link = collection.link;
                if (link && link.includes(":campus")) {
                    if (props.selectedCampus) {
                        link = link.replace(
                            ":campus",
                            props.selectedCampus.name
                        );
                    } else {
                        link = link.replace(":campus", "");
                    }
                }

                if (link && link.includes(":today")) {
                    link = link.replace(
                        ":today",
                        new Date()
                            .toLocaleString("en-us", { weekday: "long" })
                            .toLowerCase()
                    );
                }
            }

            const slide: SwiperSlideType = {
                link,
                showTitle: collection.layout.showTitle,
                externalLink: collection.layout.externalLink || false,
                slideWidth: 137,
                slideHeight: 137,
            };

            if (collection.image) {
                slide.image = collection.image;
            }

            if (collection.title) {
                slide.title = collection.title;
            }

            if (collection.layout.backgroundColor) {
                slide.backgroundColor = collection.layout.backgroundColor;
            }

            slide.squareSlide = true;

            slides.push(slide);
        }
    });

    return (
        <Swiper
            slidesPerView={slidesPerView}
            loop={false}
            uuid={props.uuid}
            slides={slides}
            desktopMinSize={props.main.desktopMinSize}
            slideWidth={137}
            slideHeight={137}
            selectedCampus={props.selectedCampus?.name}
            sectionTitle={props.eGroupSection?.title}
            pageName={props.eGroups.eGroupHomeData?.name}
        />
    );
};

export default Collections;

// export default class Collections extends React.Component<IAppProps & Props> {
//     public render() {

//     }
// }
